import { ArtModule } from 'modules/art';
import { CouponsModule } from 'modules/coupons';
import { HomeModule } from 'modules/home';
import { AuthModule } from '../modules/auth';

export const modules = [new AuthModule(), new CouponsModule(), new HomeModule(), new ArtModule()];
